var _rect, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "url(#paint0_linear_6899_293707)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 12.2844C5.5 11.7706 5.09927 11.3853 4.60811 11.2346C4.3861 11.1664 4.19116 11.0635 3.98124 10.8912C3.85864 10.7906 3.67518 10.5882 3.58707 10.4563C3.25 9.95188 3.25 9.46997 3.25 8.50613V6.49387C3.25 5.53003 3.25 5.04812 3.58707 4.54366C3.67518 4.4118 3.85864 4.20939 3.98124 4.10878C4.45023 3.7239 4.84442 3.68508 5.63279 3.60746C6.27691 3.54403 7.06191 3.5 8 3.5C8.93809 3.5 9.72309 3.54403 10.3672 3.60746C11.1556 3.68508 11.5498 3.7239 12.0188 4.10878C12.1414 4.20939 12.3248 4.4118 12.4129 4.54366C12.75 5.04812 12.75 5.53003 12.75 6.49387V8.50613C12.75 9.46997 12.75 9.95188 12.4129 10.4563C12.3248 10.5882 12.1414 10.7906 12.0188 10.8912C11.5498 11.2761 11.1556 11.3149 10.3672 11.3925C10.2586 11.4032 10.1459 11.4134 10.0292 11.4229C9.14535 11.4946 8.28974 11.7958 7.60154 12.355L6.70335 13.0848C6.57181 13.1917 6.40748 13.25 6.23799 13.25C5.83041 13.25 5.5 12.9196 5.5 12.512V12.2844Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6899_293707",
    x1: 0,
    y1: 0,
    x2: 16,
    y2: 16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EC7E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E8AE6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.b9256fd4.svg";
export { ForwardRef as ReactComponent };